import React from 'react';
import { ImportCatalogItem, ImportSourceId } from './types';
import '../../../components/common/CRMList.css';

interface ImportsListProps {
  sources: ImportCatalogItem[];
  selectedSourceId: ImportSourceId;
  onSelectSource: (sourceId: ImportSourceId) => void;
}

const ImportsList: React.FC<ImportsListProps> = ({
  sources,
  selectedSourceId,
  onSelectSource
}) => {
  return (
    <div className="list">
      <div className="list-header">
        <h3>Import</h3>
      </div>

      <div className="list-items">
        {sources.map((source) => (
          <div
            key={source.id}
            className={`list-item ${selectedSourceId === source.id ? 'selected' : ''}`}
            onClick={() => onSelectSource(source.id)}
            role="listitem"
            aria-selected={selectedSourceId === source.id}
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onSelectSource(source.id);
              }
            }}
          >
            <div className="list-item-main-info">
              <div className="list-item-name-section">
                <span className="list-item-name">{source.label}</span>
              </div>
            </div>
            <div className="list-item-details">
              <div className="list-item-detail">
                <span className="list-item-detail-value">{source.description}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImportsList;
